<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="invoice-page">
    <div class="container p-2">
      <center><img :src="logo" width="100" /></center>
      <h4 class="text-center mb-5 mt-5">PAINEL ASSISTÊNCIAS</h4>
      <!-- formFiltro inicio -->
      <div class="vx-row">
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <vx-card>
            <h6 class="mb-4">
              Busque pelo Benefíciario, Veículo ou Dependente
            </h6>
            <form role="form" @submit.stop.prevent="buscarAssociado">
              <div :class="`vx-row `">
                <div
                  class="vx-col sm:w-1/5 w-full"
                  :class="desabilitarCursoMouse(desabilitarOutrosFiltros)"
                >
                  <span>CPF/CNPJ do Benefíciario</span>
                  <vs-input
                    v-mask="'##############'"
                    class="w-full"
                    name="Cpf Cnpj"
                    id="Cpf Cnpj"
                    v-model="formFiltro.cpfCnpj"
                    :state="validateState('Cpf Cnpj')"
                    :danger="validateClass('Cpf Cnpj')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="desabilitarOutrosFiltros"
                  />
                </div>
                <div
                  class="vx-col sm:w-1/5 w-full"
                  :class="desabilitarCursoMouse(desabilitarOutrosFiltros)"
                >
                  <span>Placa</span>
                  <vs-input
                    v-mask="'AAA-#XX#'"
                    class="w-full"
                    name="Placa"
                    id="Placa"
                    v-model="formFiltro.placa"
                    :state="validateState('Placa')"
                    :danger="validateClass('Placa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="desabilitarOutrosFiltros"
                  />
                </div>
                <div
                  class="vx-col sm:w-1/5 w-full"
                  :class="desabilitarCursoMouse(desabilitarOutrosFiltros)"
                >
                  <span>Chassi</span>
                  <vs-input
                    class="w-full"
                    name="Chassi"
                    id="Chassi"
                    v-model="formFiltro.chassi"
                    :state="validateState('Chassi')"
                    :danger="validateClass('Chassi')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="desabilitarOutrosFiltros"
                  />
                </div>
                <div
                  class="vx-col sm:w-1/5 w-full"
                  :class="desabilitarCursoMouse(desabilitarFiltroDependente)"
                >
                  <span>CPF do dependente</span>
                  <vs-input
                    v-mask="'##############'"
                    class="w-full"
                    name="Cpf Dependente"
                    id="Cpf Dependente"
                    v-model="formFiltro.cpfDependente"
                    :state="validateState('Cpf Dependente')"
                    :danger="validateClass('Cpf Dependente')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="desabilitarFiltroDependente"
                  />
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-button class="my-5 w-full">Buscar</vs-button>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
      </div>
      <!-- formFiltro fim -->
      <br />
    </div>

    <!-- inicio lista de associados -->
    <div v-if="itens.length > 0" class="container p-2 mb-6">
      <vx-card>
        <vs-table
          noDataText="Nenhum Benefíciario Encontrado"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          :data="itens"
        >
          <template slot="thead">
            <vs-th sort-key="Nome">Código</vs-th>
            <vs-th sort-key="Usuario">Associado</vs-th>
            <vs-th sort-key="Usuario">Empresa</vs-th>
            <vs-th sort-key="Usuario">Cidade - Estado</vs-th>
            <vs-th sort-key="Status">Status</vs-th>
            <vs-th>Ações</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-category">
                    {{ tr.id_prospect }}
                    <Br />
                    {{ tr.tipo }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ tr.nome }}
                    <br />
                    {{ tr.email }}
                    <br />
                    {{ tr.celular ? tr.celular : tr.telefone }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ tr.nomeEmpresa }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ tr.cidade }} / {{ tr.estado }}
                  </p>
                </vs-td>

                <vs-td>
                  <p>
                    <vs-chip
                      :color="getStatusColor(tr.situacao)"
                      class="product-order-status"
                      >{{ getStatusString(tr.situacao) }}</vs-chip
                    >
                  </p>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <div class="vx-col">
                      <vs-button
                        v-tooltip="'Ver detalhes do Beneficiário'"
                        radius
                        color="primary"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-search"
                        class="d-inline"
                        @click="buscarAssociadoDetalhe(tr)"
                      ></vs-button>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <vs-pagination
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </vx-card>
    </div>
    <!-- fim da lista de associados -->

    <!-- inicio lista de dependentes -->
    <div v-if="dependentesItens.length > 0" class="container p-2 mb-6">
      <vx-card>
        <vs-table
          noDataText="Nenhum Benefíciario Encontrado"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          :data="dependentesItens"
        >
          <template slot="thead">
            <!-- <vs-th sort-key="Nome">Código</vs-th> -->
            <vs-th sort-key="Usuario">Dependente</vs-th>
            <vs-th sort-key="Usuario">Benefíciario (Titular)</vs-th>
            <vs-th sort-key="Usuario">Parentesco</vs-th>
            <vs-th sort-key="Usuario">Empresa</vs-th>
            <vs-th sort-key="Usuario">Cidade - Estado</vs-th>
            <vs-th sort-key="Status">Status</vs-th>
            <vs-th>Ações</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-category">
                    {{ tr.nome }}
                    <br />
                    {{ tr.email }}
                    <br />
                    {{ tr.celular ? tr.celular : tr.telefone }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ tr.associado.nome }}
                    <br />
                    {{ tr.associado.email }}
                    <br />
                    {{
                      tr.associado.celular
                        ? tr.associado.celular
                        : tr.associado.telefone
                    }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ tr.parentesco.nomeParentesco }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ tr.empresa.nome }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-category">
                    {{ tr.cidade }} / {{ tr.estado }}
                  </p>
                </vs-td>

                <vs-td>
                  <p>
                    <vs-chip
                      :color="getStatusColor(tr.situacao)"
                      class="product-order-status"
                      >{{ getStatusString(tr.situacao) }}</vs-chip
                    >
                  </p>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <div class="vx-col">
                      <vs-button
                        v-tooltip="'Ver detalhes do Beneficiário'"
                        radius
                        color="primary"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-search"
                        class="d-inline"
                        @click="buscarDependenteDetalhe(tr)"
                      ></vs-button>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <vs-pagination
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </vx-card>
    </div>
    <!-- fim da lista de dependentes-->

    <!-- popup info associado -->
    <vs-popup
      fullscreen
      :title="'Detalhes do benefíciario'"
      @close="popupActive = false"
      :active.sync="popupActive"
    >
      <vs-row v-if="dadosAssociado">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Dados do Beneficiário</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Código</th>
                  <td>{{ dadosAssociado.id_prospect }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Tipo</th>
                  <td>{{ dadosAssociado.tipo }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Nome</th>
                  <td>{{ dadosAssociado.nome }}</td>
                </tr>
                <tr>
                  <th class="uppercase">E-mail</th>
                  <td>{{ dadosAssociado.email }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Telefone</th>
                  <td>{{ dadosAssociado.telefone }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Celular</th>
                  <td>{{ dadosAssociado.celular }}</td>
                </tr>
                <tr v-if="dadosAssociado.cpfcnpj">
                  <th class="uppercase">
                    {{
                      dadosAssociado.tipo == 'Pessoa Física' ? 'CPF' : 'CNPJ'
                    }}
                  </th>
                  <td>
                    <p>{{ dadosAssociado.cpfcnpj }}</p>
                  </td>
                </tr>
                <tr v-if="dadosAssociado.rg_ie">
                  <th class="uppercase">
                    {{ dadosAssociado.tipo == 'Pessoa Física' ? 'RG' : 'IE' }}
                  </th>
                  <td>
                    <p>{{ dadosAssociado.rg_ie }}</p>
                  </td>
                </tr>
                <tr v-if="dadosAssociado.sexo">
                  <th class="uppercase">Sexo</th>
                  <td>
                    <p>{{ dadosAssociado.sexo }}</p>
                  </td>
                </tr>
                <tr>
                  <th class="uppercase">Status</th>
                  <td>
                    {{
                      dadosAssociado.situacao
                        ? dadosAssociado.situacao
                        : 'PROSPECT'
                    }}
                  </td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Endereço</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Cep</th>
                  <td>{{ dadosAssociado.cep }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Endereço</th>
                  <td>{{ dadosAssociado.endereco }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Número</th>
                  <td>{{ dadosAssociado.numero }}</td>
                </tr>
                <tr v-if="dadosAssociado.complemento">
                  <th class="uppercase">Complemento</th>
                  <td>{{ dadosAssociado.complemento }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Bairro</th>
                  <td>{{ dadosAssociado.bairro }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Cidade</th>
                  <td>{{ dadosAssociado.cidade }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Estado</th>
                  <td>{{ dadosAssociado.estado }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Dados Complementares</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr v-if="dadosAssociado.dataNascimento">
                  <th class="uppercase">Data de Nascimento</th>
                  <td>
                    {{ formataDataUTCAux(dadosAssociado.dataNascimento) }}
                  </td>
                </tr>
                <tr v-if="dadosAssociado.cnh">
                  <th class="uppercase">CNH</th>
                  <td>{{ dadosAssociado.cnh }}</td>
                </tr>
                <tr v-if="dadosAssociado.catCnh">
                  <th class="uppercase">Categoria</th>
                  <td>{{ dadosAssociado.catCnh }}</td>
                </tr>
                <tr v-if="dadosAssociado.dataVencimentoCnh">
                  <th class="uppercase">Data Vencimento CNH</th>
                  <td>
                    {{ formataDataUTCAux(dadosAssociado.dataVencimentoCnh) }}
                  </td>
                </tr>
                <tr v-if="dadosAssociado.consultor">
                  <th class="uppercase">Consultor</th>
                  <td>{{ dadosAssociado.consultor }}</td>
                </tr>
                <tr v-if="dadosAssociado.regional">
                  <th class="uppercase">Regional</th>
                  <td>{{ dadosAssociado.regional }}</td>
                </tr>
                <tr v-if="dadosAssociado.dataAtivacao">
                  <th class="uppercase">Data de Ativação</th>
                  <td>{{ formataDataUTCAux(dadosAssociado.dataAtivacao) }}</td>
                </tr>
                <tr>
                  <th v-if="dadosAssociado.createdAt" class="uppercase">
                    Data de Cadastro Evo
                  </th>
                  <td>{{ formataDataUTCAux(dadosAssociado.createdAt) }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row v-if="dadosAssociado">
        <vs-col>
          <vs-card>
            <vs-tabs alignment="fixed">
              <vs-tab label="Veículos">
                <div>
                  <div v-if="dadosAssociado.veiculos.length == 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum Veículo Encontrado
                    </vs-alert>
                  </div>
                  <vs-collapse v-else type="border">
                    <vs-collapse-item
                      v-for="item in dadosAssociado.veiculos"
                      :key="item.id"
                    >
                      <div slot="header">
                        {{
                          item.placa ? item.placa : 'Sem Placa - ' + item.chassi
                        }}
                        <vs-chip
                          class="mr-4"
                          :color="getStatusColor(item.Status)"
                          >{{ item.Status }}</vs-chip
                        >
                      </div>
                      <vs-row>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="5"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Código</th>
                              <td>{{ item.id_veiculo }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Grupo</th>
                              <td>{{ item.nomeGrupo }}</td>
                            </tr>

                            <tr>
                              <th class="uppercase">Chassi</th>
                              <td>{{ item.chassi }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Renavam</th>
                              <td>{{ item.renavam }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Marca</th>
                              <td>{{ item.veiculoMarca }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Modelo</th>
                              <td>{{ item.veiculoModelo }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Ano</th>
                              <td>
                                {{ item.AnoFabricacao }}/{{ item.AnoModelo }}
                              </td>
                            </tr>
                            <tr>
                              <th class="uppercase">Cor</th>
                              <td>{{ item.cor }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Combustível</th>
                              <td>{{ item.combustivel }}</td>
                            </tr>
                            <tr v-if="item.qtdPortas">
                              <th class="uppercase">Qtd Portas</th>
                              <td>{{ item.qtdPortas }}</td>
                            </tr>
                            <tr v-if="item.cilindradas">
                              <th class="uppercase">Cilindradas</th>
                              <td>{{ item.cilindradas }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Código Fipe</th>
                              <td>{{ item.codigoFipe }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Valor Fipe</th>
                              <td>{{ item.valorFipe | currency }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Valor Protegido</th>
                              <td>{{ item.valorCobertura | currency }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Cota</th>
                              <td>{{ item.cotaTabela }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Dia Vencimento</th>
                              <td>{{ item.diaVencimento }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Vendedor</th>
                              <td>{{ item.vendedor_inicial }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Data Criação</th>
                              <td>{{ formataDataUTCAux(item.createdAt) }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">
                                Forma de Pagamento Mensal
                              </th>
                              <td>{{ item.pagamentoMensal }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Restrições</th>
                              <td>
                                <p
                                  v-for="item in item.restricoes"
                                  :key="item.id"
                                >
                                  {{ item.descricao }}
                                </p>
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="7"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Produto</th>
                              <th class="uppercase">Fornecedor</th>
                              <th class="uppercase">Status</th>
                            </tr>
                            <tr
                              v-for="produto in item.produtos"
                              :key="produto.id"
                            >
                              <td>
                                {{ produto.descricao_produto_sga }}
                              </td>
                              <td class="text-center" valing="top">
                                {{ produto.nomeFornecedor }}
                              </td>
                              <td class="text-center" valing="top">
                                <vs-chip
                                  class="mr-4"
                                  :color="getStatusColor(produto.situacao)"
                                  >{{ produto.situacao }}</vs-chip
                                >
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </vs-tab>
              <vs-tab label="Dependentes">
                <div>
                  <div v-if="dadosAssociado.dependentes.length == 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum dependente encontrado
                    </vs-alert>
                  </div>

                  <vs-collapse v-else type="border">
                    <vs-collapse-item
                      v-for="dependente in dadosAssociado.dependentes"
                      :key="dependente.idDependente"
                    >
                      <div slot="header">
                        {{ dependente.nome }}
                        <vs-chip
                          class="mr-4"
                          :color="getStatusColor(dependente.situacao)"
                          >{{ dependente.situacao }}</vs-chip
                        >
                      </div>

                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-w="5"
                        vs-sm="12"
                        vs-xs="12"
                      >
                        <!-- dados depentente -->
                        <vs-card>
                          <div slot="header">
                            <h3>Dados do dependente</h3>
                          </div>
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Código</th>
                              <td>{{ dependente.idDependente }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Nome</th>
                              <td>{{ dependente.nome }}</td>
                            </tr>
                            <tr v-if="dependente.nomeParentesco">
                              <th class="uppercase">Parentesco</th>
                              <td>{{ dependente.nomeParentesco }}</td>
                            </tr>
                            <tr v-if="dependente.email">
                              <th class="uppercase">E-mail</th>
                              <td>{{ dependente.email }}</td>
                            </tr>
                            <tr v-if="dependente.telefone">
                              <th class="uppercase">Telefone</th>
                              <td>{{ dependente.telefone }}</td>
                            </tr>
                            <tr v-if="dependente.celular">
                              <th class="uppercase">Celular</th>
                              <td>{{ dependente.celular }}</td>
                            </tr>
                            <tr v-if="dependente.cpf">
                              <th class="uppercase">CPF</th>
                              <td>{{ dependente.cpf }}</td>
                            </tr>
                            <tr v-if="dependente.rg">
                              <th class="uppercase">RG</th>
                              <td>
                                <p>{{ dependente.rg }}</p>
                              </td>
                            </tr>
                            <tr v-if="dependente.nomeDaMae">
                              <th class="uppercase">Nome da mãe</th>
                              <td>{{ dependente.nomeDaMae }}</td>
                            </tr>
                            <tr v-if="dependente.nomeDoPai">
                              <th class="uppercase">Nome do pai</th>
                              <td>{{ dependente.nomeDoPai }}</td>
                            </tr>
                            <tr v-if="dependente.sexo">
                              <th class="uppercase">Sexo</th>
                              <td>{{ dependente.sexo }}</td>
                            </tr>
                            <tr v-if="dependente.escolaridade">
                              <th class="uppercase">Escolaridade</th>
                              <td>{{ dependente.escolaridade }}</td>
                            </tr>
                            <tr v-if="dependente.estadoCivil">
                              <th class="uppercase">Estado civil</th>
                              <td>{{ dependente.estadoCivil }}</td>
                            </tr>
                            <tr v-if="dependente.dataNascimento">
                              <th class="uppercase">Data de Nascimento</th>
                              <td>
                                {{
                                  formataDataUTCAux(dependente.dataNascimento)
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th class="uppercase">STATUS</th>
                              <td>{{ dependente.situacao }}</td>
                            </tr>
                            <!-- Endereco -->
                            <tr v-if="dependente.cep">
                              <th class="uppercase">Cep</th>
                              <td>{{ dependente.cep }}</td>
                            </tr>
                            <tr v-if="dependente.endereco">
                              <th class="uppercase">Endereço</th>
                              <td>{{ dependente.endereco }}</td>
                            </tr>
                            <tr v-if="dependente.numero">
                              <th class="uppercase">Número</th>
                              <td>{{ dependente.numero }}</td>
                            </tr>
                            <tr v-if="dependente.complemento">
                              <th class="uppercase">Complemento</th>
                              <td>{{ dependente.complemento }}</td>
                            </tr>
                            <tr v-if="dependente.bairro">
                              <th class="uppercase">Bairro</th>
                              <td>{{ dependente.bairro }}</td>
                            </tr>
                            <tr v-if="dependente.cidade">
                              <th class="uppercase">Cidade</th>
                              <td>{{ dependente.cidade }}</td>
                            </tr>
                            <tr v-if="dependente.cidade">
                              <th class="uppercase">Estado</th>
                              <td>{{ dependente.estado }}</td>
                            </tr>
                            <!-- Dados complementares -->
                            <tr v-if="dependente.cnh">
                              <th class="uppercase">CNH</th>
                              <td>{{ dependente.cnh }}</td>
                            </tr>
                            <tr v-if="dependente.catCnh">
                              <th class="uppercase">Categoria</th>
                              <td>{{ dependente.catCnh }}</td>
                            </tr>
                            <tr v-if="dependente.dataVencimentoCnh">
                              <th class="uppercase">Data Vencimento CNH</th>
                              <td>
                                {{
                                  formataDataUTCAux(
                                    dependente.dataVencimentoCnh,
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="dependente.consultor">
                              <th class="uppercase">Consultor</th>
                              <td>{{ dependente.consultor }}</td>
                            </tr>
                            <tr v-if="dependente.regional">
                              <th class="uppercase">Regional</th>
                              <td>{{ dependente.regional }}</td>
                            </tr>
                            <tr v-if="dependente.dataAtivacao">
                              <th class="uppercase">Data de Ativação</th>
                              <td>
                                {{ formataDataUTCAux(dependente.dataAtivacao) }}
                              </td>
                            </tr>
                            <tr>
                              <th v-if="dependente.createdAt" class="uppercase">
                                Data de Cadastro Evo
                              </th>
                              <td>
                                {{ formataDataUTCAux(dependente.createdAt) }}
                              </td>
                            </tr>
                          </table>
                        </vs-card>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-w="7"
                        vs-sm="12"
                        vs-xs="12"
                      >
                        <vs-card>
                          <div slot="header">
                            <h3>Produtos</h3>
                          </div>
                          <div v-if="dependente.produtos.length == 0">
                            <vs-alert
                              style="height: auto"
                              active="true"
                              color="danger"
                            >
                              Nenhum produto encontrado
                            </vs-alert>
                          </div>
                          <table v-else class="table table-bordered">
                            <tr>
                              <th class="uppercase">Produto</th>
                              <th class="uppercase">valor</th>
                              <th class="uppercase">Status</th>
                            </tr>
                            <tr
                              v-for="(produto, index) in dependente.produtos"
                              :key="produto.index"
                            >
                              <td>
                                {{ produto.descricao_produto_sga }}
                                <vs-chip
                                  v-if="
                                    produto.isMensal == true ||
                                    produto.isMensal == null ||
                                    produto.isMensal == undefined
                                  "
                                  class="mr-4"
                                  :color="'warning'"
                                >
                                  Mensal
                                </vs-chip>
                              </td>
                              <td class="text-center" valing="top">
                                {{ produto.valor | currency }}
                              </td>
                              <td class="text-center" valing="top">
                                <vs-chip
                                  class="mr-4"
                                  :color="getStatusColor(produto.situacao)"
                                  >{{ produto.situacao }}</vs-chip
                                >
                              </td>
                            </tr>
                          </table>
                        </vs-card>
                      </vs-col>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-popup>

    <!-- popup info dependentes -->
    <vs-popup
      fullscreen
      :title="'Detalhes do dependente'"
      @close="
        popupDependenteActive = false;
        dadosDependente = null;
      "
      :active.sync="popupDependenteActive"
    >
      <vs-row v-if="dadosDependente">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card v-if="dadosDependente.associado">
            <div slot="header">
              <h3>Dados do Beneficiário</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Código</th>
                  <td>{{ dadosDependente.associado.idProspect }}</td>
                </tr>
                <tr v-if="dadosDependente.associado.tipo">
                  <th class="uppercase">Tipo</th>
                  <td>{{ dadosDependente.associado.tipo }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Nome</th>
                  <td>{{ dadosDependente.associado.nome }}</td>
                </tr>
                <tr v-if="dadosDependente.associado.dataNascimento">
                  <th class="uppercase">DATA NASCIMENTO</th>
                  <td>
                    {{
                      formataDataUTCAux(
                        dadosDependente.associado.dataNascimento,
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.email">
                  <th class="uppercase">E-mail</th>
                  <td>{{ dadosDependente.associado.email }}</td>
                </tr>
                <tr v-if="dadosDependente.associado.telefone">
                  <th class="uppercase">Telefone</th>
                  <td>{{ dadosDependente.associado.telefone }}</td>
                </tr>
                <tr v-if="dadosDependente.associado.celular">
                  <th class="uppercase">Celular</th>
                  <td>{{ dadosDependente.associado.celular }}</td>
                </tr>
                <tr v-if="dadosDependente.associado.cpfcnpj">
                  <th class="uppercase">
                    {{
                      dadosDependente.associado.tipo == 'Pessoa Física'
                        ? 'CPF'
                        : 'CNPJ'
                    }}
                  </th>
                  <td>
                    <p>{{ dadosDependente.associado.cpfcnpj }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.rg_ie">
                  <th class="uppercase">
                    {{
                      dadosDependente.associado.tipo == 'Pessoa Física'
                        ? 'RG'
                        : 'IE'
                    }}
                  </th>
                  <td>
                    <p>{{ dadosDependente.associado.rg_ie }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.cnh">
                  <th class="uppercase">CNH</th>
                  <td>
                    <p>{{ dadosDependente.associado.cnh }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.catCnh">
                  <th class="uppercase">Categoria CNH</th>
                  <td>
                    <p>{{ dadosDependente.associado.catCnh }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.sexo">
                  <th class="uppercase">Sexo</th>
                  <td>
                    <p>{{ dadosDependente.associado.sexo }}</p>
                  </td>
                </tr>
                <tr>
                  <th class="uppercase">Status</th>
                  <td>
                    {{
                      dadosDependente.associado.situacao
                        ? dadosDependente.associado.situacao
                        : 'PROSPECT'
                    }}
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.cep">
                  <th class="uppercase">CEP</th>
                  <td>
                    <p>{{ dadosDependente.associado.cep }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.endereco">
                  <th class="uppercase">ENDERECO</th>
                  <td>
                    <p>{{ dadosDependente.associado.endereco }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.numero">
                  <th class="uppercase">NÚMERO</th>
                  <td>
                    <p>{{ dadosDependente.associado.numero }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.bairo">
                  <th class="uppercase">BAIRRO</th>
                  <td>
                    <p>{{ dadosDependente.associado.bairro }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.complemento">
                  <th class="uppercase">COMPLEMENTO</th>
                  <td>
                    <p>{{ dadosDependente.associado.complemento }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.estado">
                  <th class="uppercase">ESTADO</th>
                  <td>
                    <p>{{ dadosDependente.associado.estado }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.associado.cidade">
                  <th class="uppercase">ENDERECO</th>
                  <td>
                    <p>{{ dadosDependente.associado.cidade }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Dados do dependente</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">CÓDIGO</th>
                  <td>{{ dadosDependente.idDependente }}</td>
                </tr>
                <tr>
                  <th class="uppercase">NOME</th>
                  <td>{{ dadosDependente.nome }}</td>
                </tr>
                <tr v-if="dadosDependente.parentesco.nomeParentesco">
                  <th class="uppercase">PARENTESCO</th>
                  <td>{{ dadosDependente.parentesco.nomeParentesco }}</td>
                </tr>
                <tr v-if="dadosDependente.email">
                  <th class="uppercase">E-MAIL</th>
                  <td>{{ dadosDependente.email }}</td>
                </tr>
                <tr v-if="dadosDependente.telefone">
                  <th class="uppercase">TELEFONE</th>
                  <td>{{ dadosDependente.telefone }}</td>
                </tr>
                <tr v-if="dadosDependente.celular">
                  <th class="uppercase">CELULAR</th>
                  <td>{{ dadosDependente.celular }}</td>
                </tr>
                <tr v-if="dadosDependente.cpf">
                  <th class="uppercase">CPF</th>
                  <td>{{ dadosDependente.cpf }}</td>
                </tr>
                <tr v-if="dadosDependente.rg">
                  <th class="uppercase">RG</th>
                  <td>
                    <p>{{ dadosDependente.rg }}</p>
                  </td>
                </tr>
                <tr v-if="dadosDependente.nomeDaMae">
                  <th class="uppercase">NOME DA MÃE</th>
                  <td>{{ dadosDependente.nomeDaMae }}</td>
                </tr>
                <tr v-if="dadosDependente.nomeDoPai">
                  <th class="uppercase">NOME DO PAI</th>
                  <td>{{ dadosDependente.nomeDoPai }}</td>
                </tr>
                <tr v-if="dadosDependente.sexo">
                  <th class="uppercase">SEXO</th>
                  <td>{{ dadosDependente.sexo }}</td>
                </tr>
                <tr v-if="dadosDependente.escolaridade">
                  <th class="uppercase">ESCOLARIDADE</th>
                  <td>{{ dadosDependente.escolaridade }}</td>
                </tr>
                <tr v-if="dadosDependente.estadoCivil">
                  <th class="uppercase">ESTADO CIVIL</th>
                  <td>{{ dadosDependente.estadoCivil }}</td>
                </tr>
                <tr v-if="dadosDependente.dataNascimento">
                  <th class="uppercase">Data de Nascimento</th>
                  <td>
                    {{ formataDataUTCAux(dadosDependente.dataNascimento) }}
                  </td>
                </tr>
                <tr>
                  <th class="uppercase">STATUS</th>
                  <td>{{ dadosDependente.situacao }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>

        <vs-col vs-w="4" vs-sm="12" vs-xs="12">
          <vs-card>
            <div slot="header">
              <h3>Endereço do dependente</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Cep</th>
                  <td>{{ dadosDependente.cep }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Endereço</th>
                  <td>{{ dadosDependente.endereco }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Número</th>
                  <td>{{ dadosDependente.numero }}</td>
                </tr>
                <tr v-if="dadosDependente.complemento">
                  <th class="uppercase">Complemento</th>
                  <td>{{ dadosDependente.complemento }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Bairro</th>
                  <td>{{ dadosDependente.bairro }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Cidade</th>
                  <td>{{ dadosDependente.cidade }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Estado</th>
                  <td>{{ dadosDependente.estado }}</td>
                </tr>
              </table>
            </div>
          </vs-card>

          <vs-card>
            <div slot="header">
              <h3>Dados Complementares do dependente</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr v-if="dadosDependente.cnh">
                  <th class="uppercase">CNH</th>
                  <td>{{ dadosDependente.cnh }}</td>
                </tr>
                <tr v-if="dadosDependente.catCnh">
                  <th class="uppercase">Categoria</th>
                  <td>{{ dadosDependente.catCnh }}</td>
                </tr>
                <tr v-if="dadosDependente.dataVencimentoCnh">
                  <th class="uppercase">Data Vencimento CNH</th>
                  <td>
                    {{ formataDataUTCAux(dadosDependente.dataVencimentoCnh) }}
                  </td>
                </tr>
                <tr v-if="dadosDependente.consultor">
                  <th class="uppercase">Consultor</th>
                  <td>{{ dadosDependente.consultor }}</td>
                </tr>
                <tr v-if="dadosDependente.regional">
                  <th class="uppercase">Regional</th>
                  <td>{{ dadosDependente.regional }}</td>
                </tr>
                <tr v-if="dadosDependente.dataAtivacao">
                  <th class="uppercase">Data de Ativação</th>
                  <td>{{ formataDataUTCAux(dadosDependente.dataAtivacao) }}</td>
                </tr>
                <tr>
                  <th v-if="dadosDependente.createdAt" class="uppercase">
                    Data de Cadastro Evo
                  </th>
                  <td>{{ formataDataUTCAux(dadosDependente.createdAt) }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>

        <!-- <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Dados Complementares</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr v-if="dadosDependente.dataNascimento">
                  <th class="uppercase">Data de Nascimento</th>
                  <td>
                    {{ formataDataUTCAux(dadosDependente.dataNascimento) }}
                  </td>
                </tr>
                <tr v-if="dadosDependente.cnh">
                  <th class="uppercase">CNH</th>
                  <td>{{ dadosDependente.cnh }}</td>
                </tr>
                <tr v-if="dadosDependente.catCnh">
                  <th class="uppercase">Categoria</th>
                  <td>{{ dadosDependente.catCnh }}</td>
                </tr>
                <tr v-if="dadosDependente.dataVencimentoCnh">
                  <th class="uppercase">Data Vencimento CNH</th>
                  <td>
                    {{ formataDataUTCAux(dadosDependente.dataVencimentoCnh) }}
                  </td>
                </tr>
                <tr v-if="dadosDependente.consultor">
                  <th class="uppercase">Consultor</th>
                  <td>{{ dadosDependente.consultor }}</td>
                </tr>
                <tr v-if="dadosDependente.regional">
                  <th class="uppercase">Regional</th>
                  <td>{{ dadosDependente.regional }}</td>
                </tr>
                <tr v-if="dadosDependente.dataAtivacao">
                  <th class="uppercase">Data de Ativação</th>
                  <td>{{ formataDataUTCAux(dadosDependente.dataAtivacao) }}</td>
                </tr>
                <tr>
                  <th v-if="dadosDependente.createdAt" class="uppercase">
                    Data de Cadastro Evo
                  </th>
                  <td>{{ formataDataUTCAux(dadosDependente.createdAt) }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col> -->
      </vs-row>

      <vs-row v-if="dadosDependente">
        <vs-card>
          <div slot="header">
            <h3>Produtos</h3>
          </div>
          <div v-if="dadosDependente.produtos.length == 0">
            <vs-alert style="height: auto" active="true" color="danger">
              Nenhum produto encontrado
            </vs-alert>
          </div>
          <table v-else class="table table-bordered">
            <tr>
              <th class="uppercase">Produto</th>
              <th class="uppercase">Valor</th>
              <th class="uppercase">Status</th>
            </tr>
            <tr
              v-for="(produto, index) in dadosDependente.produtos"
              :key="produto.index"
            >
              <td>
                <vs-chip
                  v-if="
                    produto.isMensal == true ||
                    produto.isMensal == null ||
                    produto.isMensal == undefined
                  "
                  class="mr-4"
                  :color="'warning'"
                >
                  Mensal
                </vs-chip>
                {{ produto.nomeProduto }}
              </td>
              <td class="text-center" valing="top">
                {{ produto.valor | currency }}
              </td>
              <td class="text-center" valing="top">
                <vs-chip
                  class="mr-4"
                  :color="getStatusColor(produto.situacao)"
                  >{{ produto.situacao }}</vs-chip
                >
              </td>
            </tr>
          </table>
        </vs-card>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import service from '../../services';
import moment from 'moment';
import vSelect from 'vue-select';
import locale from '../../locale';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { decryptData } from '../../services/decryptData';

export default {
  watch: {
    'formFiltro.cpfDependente': function (value) {
      this.desabilitarOutrosFiltros = this.habilitaDesabilitaFiltros(value);
    },
    'formFiltro.cpfCnpj': function (value) {
      this.desabilitarFiltroDependente = this.habilitaDesabilitaFiltros(value);
      this.verificaOutrosFiltros(this.desabilitarFiltroDependente);
    },
    'formFiltro.placa': function (value) {
      this.desabilitarFiltroDependente = this.habilitaDesabilitaFiltros(value);
      this.verificaOutrosFiltros(this.desabilitarFiltroDependente);
    },
    'formFiltro.chassi': function (value) {
      this.desabilitarFiltroDependente = this.habilitaDesabilitaFiltros(value);
      this.verificaOutrosFiltros(this.desabilitarFiltroDependente);
    },
  },
  data() {
    return {
      popupDependenteActive: false,
      dadosDependente: null,
      desabilitarFiltroDependente: false,
      desabilitarOutrosFiltros: false,
      dependentesItens: [],
      formStatus: {},
      formFiltro: {},
      status: [],
      logs: [],
      popupActive: false,
      dadosAssociado: null,
      selected: [],
      itens: [],
      itemsPerPage: 25,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      isMounted: false,
      acao: ['Inativar', 'Reativar'],
      logo: 'https://bboneapp.s3.amazonaws.com/evo-gerencial-color.png',
    };
  },
  methods: {
    formataDataUTCAux(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    getStatusColor(data) {
      if (data == 'ATIVO') return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Prospect';
      return data;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscarAssociadoDetalhe(item) {
      this.$vs.loading();
      var objSend = {};
      objSend.idAssociado = item.id_prospect;
      objSend.idEmpresa = item.id_empresa;
      service
        .post('Externo', 'DetalheAssociado', objSend)
        .then((res) => {
          var aux = res.data;
          var propostas = [];
          var veiculos = [];
          var dependentes = [];

          if (aux.propostas) propostas = JSON.parse(res.data.propostas);
          if (aux.veiculos) veiculos = JSON.parse(res.data.veiculos);
          if (aux.dependentes) dependentes = JSON.parse(res.data.dependentes);

          this.dadosAssociado = res.data;
          delete this.dadosAssociado.boletos;
          delete this.dadosAssociado.propostas;
          delete this.dadosAssociado.veiculos;
          delete this.dadosAssociado.registrosFinanceiros;
          delete this.dadosAssociado.dependentes;

          this.dadosAssociado.propostas = propostas;
          this.dadosAssociado.veiculos = veiculos;
          this.dadosAssociado.dependentes = dependentes;

          this.popupActive = true;
          this.$vs.loading.close();
          this.$forceUpdate();
        })
        .catch((e) => {
          this.error = true;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscarAssociado() {
      var objSend = {};
      if (this.formFiltro) {
        objSend = { ...this.formFiltro };
      }

      console.log(objSend);

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = 0;

      if (
        !this.formFiltro.cpfDependente &&
        !this.formFiltro.cpfCnpj &&
        !this.formFiltro.placa &&
        !this.formFiltro.chassi
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Pelo Menos um Filtro é necessário',
          color: 'danger',
        });
        return;
      }

      if (!this.formFiltro.cpfDependente) {
        this.$vs.loading();

        this.dependentesItens = [];
        service
          .post('Externo', 'listarAssociadosFiltro', objSend)
          .then((res) => {
            this.exibir = true;
            this.itens = [];
            console.log('682 res.data', res.data);
            this.qtdTotal = res.data.qtd;
            this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

            if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
            this.qtdPaginas = parseInt(this.qtdPaginas);

            if (this.qtdTotal > 0) {
              res.data.associados.forEach((element) => {
                this.itens.push(element);
              });
            }

            this.$vs.loading.close();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.itens = [];
        this.buscarDependentes(objSend);
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    habilitaDesabilitaFiltros(value) {
      const inputHabilitado = value.length > 0 ? true : false;
      return inputHabilitado;
    },
    verificaOutrosFiltros(verificarOutrosFiltros) {
      const numCaracCpfCnpj = this.formFiltro.hasOwnProperty('cpfCnpj')
        ? this.formFiltro.cpfCnpj.length
        : 0;

      const numCaracPlaca = this.formFiltro.hasOwnProperty('placa')
        ? this.formFiltro.placa.length
        : 0;

      const numCaracChassi = this.formFiltro.hasOwnProperty('chassi')
        ? this.formFiltro.chassi.length
        : 0;

      if (verificarOutrosFiltros === false) {
        this.desabilitarFiltroDependente =
          numCaracCpfCnpj > 0 || numCaracPlaca > 0 || numCaracChassi > 0
            ? true
            : false;
      }
    },
    buscarDependentes(objSend) {
      this.$vs.loading();
      service
        .post('Externo', 'listarDependentesFiltro', objSend)
        .then((res) => {
          this.exibir = true;
          this.dependentesItens = [];

          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.dependentes.forEach((element) => {
              this.dependentesItens.push(element);
            });
          }

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscarDependenteDetalhe(item) {
      const { produtos: idsProdutos, idDependente } = item;

      const temProdutos = idsProdutos.length;
      if (temProdutos) {
        this.$vs.loading();
        service
          .post('Externo', 'listarProdutosDependente', { idDependente })
          .then((res) => {
            const produtosDetalhes = res.data;

            const produtos = idsProdutos.reduce((acc, produtoDependente) => {
              const produtoItem = produtosDetalhes.filter(
                (item) => item.idProduto === produtoDependente.idProduto,
              );

              const {
                idProduto,
                valor,
                situacao,
                produtos: { nomeProduto, isMensal },
              } = produtoItem[0];

              acc.push({
                idProduto,
                nomeProduto,
                valor,
                isMensal,
                situacao,
              });

              return acc;
            }, []);

            const detalhesDependete = {
              ...item,
              produtos,
            };

            this.dadosDependente = detalhesDependete;
            this.popupDependenteActive = true;

            this.$vs.loading.close();
            return;
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      }

      this.dadosDependente = item;
      this.popupDependenteActive = true;
    },
    desabilitarCursoMouse(status) {
      const classeCssDesabilitarMouse = 'desabilitaMouse';
      if (status) return classeCssDesabilitarMouse;
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
  },
  components: {
    'v-select': vSelect,
    VueJsonPretty,
  },
};
</script>
<style scoped lang="scss">
.desabilitaMouse {
  cursor: not-allowed;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  border: 1px solid gray;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vdp-datepicker input {
  width: 100%;
}
</style>
